import type { VisitorData } from '../auth'
import { email, type FormControl, FormControlType, INPUT_MAXLENGTH, RATING_TEXT_MAXLENGTH, required } from '../form'
import { getFromStorage, removeFromLocalStorage, setToStorage, StorageItem } from '../storage'
import { type TicketForm, TicketFormOptions, type TicketFormValues } from './types'

export const createTicketFormControls = (visitor: VisitorData): FormControl<TicketForm>[] => {
	return [
		{
			type: FormControlType.Text,
			subType: 'text',
			name: TicketFormOptions.Name,
			label: 'authForm.label.name',
			placeholder: 'authForm.yourName',
			value: visitor?.name ?? '',
			validators: [required()],
			maxLength: INPUT_MAXLENGTH,
		},
		{
			type: FormControlType.Text,
			subType: 'email',
			name: TicketFormOptions.Email,
			label: 'authForm.label.email',
			placeholder: 'authForm.yourEmail',
			value: visitor?.email ?? '',
			validators: [required(), email()],
			maxLength: INPUT_MAXLENGTH,
		},
		{
			type: FormControlType.Text,
			subType: 'text',
			name: TicketFormOptions.Message,
			label: 'ticketForm.label.message',
			placeholder: 'ticketForm.message.placeholder',
			value: '',
			validators: [required()],
			maxLength: RATING_TEXT_MAXLENGTH,
		},
	]
}

export const loadTicketFormFromStorage = (): TicketFormValues | null => {
	const ticketFormData = getFromStorage(StorageItem.TicketForm)
	if (!ticketFormData) return null

	try {
		return JSON.parse(ticketFormData) as TicketFormValues
	} catch {
		return null
	}
}

export const saveTicketFormFieldToStorage = (field: TicketForm, value: string) => {
	const storedValues = loadTicketFormFromStorage()
	const updatedField = { [field]: value }
	const updatedValues = storedValues ? { ...storedValues, ...updatedField } : updatedField
	setToStorage({ name: StorageItem.TicketForm, value: JSON.stringify(updatedValues) })
}

export const removeTicketFormFromStorage = () => {
	removeFromLocalStorage(StorageItem.TicketForm)
}
